import React, { useState } from 'react'
import StockHistoryListContainer from './StockHistoryListContainer';
import TranInfoViewModalContainer from './TranInfoViewModalContainer';

const StockHistoryContainer = () => {
    const [type, setType] = useState(null);
    const [selectedId, setSelectedId] = useState(null)
    const [open, setOpen] = useState(false);
    const handleOpen = (param) => {
        setSelectedId(param.trnUuid);
        setType(param.trnTyp)
        setOpen(true);

    };
    const handleClose = () => {
        setOpen(false);
        setType(null)
        setSelectedId(null);
    };

    const onSelectedData = (data) => {
        handleOpen(data);
    }



    return (
        <div>
            <StockHistoryListContainer onSelectedData={onSelectedData} />
            {open && <TranInfoViewModalContainer open={open} handleClose={handleClose} id={selectedId} />}

        </div>
    )
}

export default StockHistoryContainer